// NUTS 2026 as SSB publishes it (klass version 3319), the same codes Doffin's eForms SDK 1.13 accepts.
export const NORWEGIAN_COUNTIES: { code: string; name: string; number: string }[] = [
  { code: "NO092", name: "Agder", number: "42" },
  { code: "NO084", name: "Akershus", number: "32" },
  { code: "NO085", name: "Buskerud", number: "33" },
  { code: "NO073", name: "Finnmark", number: "56" },
  { code: "NO020", name: "Innlandet", number: "34" },
  { code: "NO0B1", name: "Jan Mayen", number: "22" },
  { code: "NO0A3", name: "Møre og Romsdal", number: "15" },
  { code: "NO071", name: "Nordland", number: "18" },
  { code: "NO081", name: "Oslo", number: "03" },
  { code: "NO0A1", name: "Rogaland", number: "11" },
  { code: "NO0B2", name: "Svalbard", number: "21" },
  { code: "NO094", name: "Telemark", number: "40" },
  { code: "NO072", name: "Troms", number: "55" },
  { code: "NO060", name: "Trøndelag", number: "50" },
  { code: "NO093", name: "Vestfold", number: "39" },
  { code: "NO0A2", name: "Vestland", number: "46" },
  { code: "NO083", name: "Østfold", number: "31" },
];

export const countyName = (code: string | null | undefined): string | undefined =>
  NORWEGIAN_COUNTIES.find((county) => county.code === code)?.name;
